import type { Contact } from '@features/contacts/types/contact'

interface GetMatchedSupplierContactIdOptions {
  contacts?: Contact[]
  supplierName?: string
}

// the review entry API only exposes the supplier as a display name; we prefill the
// supplier select by matching that name against the organization supplier contacts
export const getMatchedSupplierContactId = (options: GetMatchedSupplierContactIdOptions): string | null => {
  const { contacts, supplierName } = options

  const normalizedSupplierName = supplierName?.trim().toLowerCase()

  if (!normalizedSupplierName || !contacts?.length) {
    return null
  }

  const matchedContact = contacts.find((contact) => contact.name?.trim().toLowerCase() === normalizedSupplierName)

  return matchedContact?.id ?? null
}
